'use strict';

import ProductService from "../providers/api/product-service";
import BannerService from "../providers/api/banner-service";
import CacheService from "../providers/cache";
import ImageService from "../providers/api/image-service";

/**
 * @description
 * Esse módulo tem como finalidade agrupar handlers da PWA, como storage offline e outros.
 */

const cacheService = new CacheService(),
    imageService = new ImageService();

const doStoreAllProducts = () => {
    const productService = new ProductService();

    productService.doGetAllProducts().then((res) => {
        const products = res.data.data;
        localStorage.products = JSON.stringify(products);
    });
};

const doStoreOfflineBanner = () => {
    const bannerService = new BannerService();

    bannerService.doGetOffline().then((res) => {
        const banners = res.data.data;
        if (banners.length) {
            localStorage.banner = JSON.stringify(banners[0]);
        }
    });
};

const doStoreImages = () => {
    imageService.doGetAll()
        .then((res) => {
            const data = res.data,
                images = data.data.map((item) => {
                    item = item.replace(/\/var\/www\/site\/public/g, '');
                    return item;
                });

            cacheService.storeCache('images', images);
        });
};

doStoreAllProducts();
doStoreOfflineBanner();
// doStoreImages();



// WEBPACK FOOTER //
// ./resources/site/js/offline/index.js